<template>
  <vertical-space :top="marginTop" :bottom="marginBottom" :backgroundColor="bgColor">
    <div class="double-image-offset">
      <div class="double-image-offset__wrapper">
        <div
          class="image-container first"
          :style="{'padding-bottom': this.firstImageSizeRatio ? this.firstImageSizeRatio : ''}"
        >
          <img :data-src="image" alt class="lazy" />
        </div>
        <div
          class="image-container second"
          :style="{'padding-bottom': this.secondImageSizeRatio ? this.secondImageSizeRatio : ''}"
        >
          <img :data-src="secondImage" alt class="lazy" />
        </div>
      </div>
    </div>
  </vertical-space>
</template>

<script>
import LazyLoad from "vanilla-lazyload";
import verticalSpace from "@/components/vertical-space.vue"

export default {
  name: "CaseViewDuoOffsetImage",
  components: { verticalSpace },
  data() {
    return {
      firstImageSizeRatio: "",
      secondImageSizeRatio: ""
    };
  },
  props: {
    image: String,
    secondImage: String,
    bgColor: String,

    marginTop: { type: Number, default: 0 },
    marginBottom: { type: Number, default: 0 }
  },
  methods: {
    reveal(entries) {
      const children = entries[0].target.children[0].children;

      if (entries[0].intersectionRatio > 0.1) {
        for (let child of children) {
          child.classList.remove("unseen");
        }
      }
    },
    getImageMeta(url) {
      return new Promise((resolve, reject) => {
        let img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = url;
      });
    },
    getImageSizeRatio(dataRef, image) {
      return this.getImageMeta(image).then(meta => {
        const ratio = (meta.height / meta.width) * 100 + "%";
        this[dataRef] = ratio;
      });
    }
  },
  mounted() {
    new LazyLoad({
      elements_selector: ".lazy"
    });
    this.getImageSizeRatio("firstImageSizeRatio", this.image);
    this.getImageSizeRatio("secondImageSizeRatio", this.secondImage);
  }
};
</script>

<style lang="scss">
@import "../scss/globals.scss";

.double-image-offset {
  padding: 0 $margin1-8;
  @media screen and (min-width: 440px) {
    padding: 0 $margin1-4;
  }
  @media screen and (min-width: 769px) {
    padding: 0 $margin1-2;
  }
  @media screen and (min-width: 1025px) {
    padding: 0 $margin2-1;
  }

  &__wrapper {
    width: 100%;

    display: grid;
    grid-template-columns: repeat(1, 1fr);
    @media screen and (min-width: 440px) {
      grid-template-columns: repeat(2, 1fr);
    }

    .image-container {
      &.first {
        position: relative;
        display: flex;
        align-items: flex-start;
        margin: 0;
        @media screen and (min-width: 440px) {
          margin: 0 $margin1-4 $margin1-8 0;
        }
        @media screen and (min-width: 769px) {
          margin: 0 $margin1-4 $margin1-1 0;
        }
        @media screen and (min-width: 1025px) {
          margin: 0 $margin1-2 $margin2-1 0;
        }
      }

      &.second {
        position: relative;
        margin: $margin1-2 0 0 0;
        @media screen and (min-width: 440px) {
          margin: $margin1-1 0 0 $margin1-8;
        }
        @media screen and (min-width: 769px) {
          margin: $margin1-1 0 0 $margin1-4;
        }
        @media screen and (min-width: 1025px) {
          margin: $margin3-1 0 0 $margin1-2;
        }
      }

      img {
        position: absolute;
        top: 0;
        left: 0;
        max-width: 100%;
      }
    }
  }
}
</style>
